export const ONE_PLUS_N_BUNDLE = "1+nBundle";
export const DEFAULT_BUNDLE = "defaultBundle";
export const M_PLUS_N_BUNDLE = "m+nBundle";
export const ROLE_FOA = "FOA";
import FallbackImg from "../assets/images/fallbackImg.png";

export const SEARCH_TYPES = {
  SUGGESTED: "suggested",
  DIRECT: "direct",
};

export const HOLDER_IMAGE = FallbackImg;


export const LeftNavMapping =
  [
    { type: 'SOP', URL: '/orders/soporders', subURL: ['/orders/soporders/modify', '/orders/soporders/detail', '/orders/soporders/combine'] },
    { type: 'MyList', URL: '/mylist', subURL: ['/specialProduct', '/createList', 'product'] },
    { type: 'Orders', URL: '/orders/orders', subURL: ['/orders/orderDetails', '/orders/returns'] },
    { type: 'Online Return', URL: '/onlinereturn/returns', subURL: ['/onlinereturn/returndetails'] },
    { type: 'Center Return', URL: '/onlinereturn/centerreturns', subURL: ['/onlinereturn/centerreturndetails'] },
    { type: 'Profile', URL: '/profile', subURL: ['/profile/changeEmail', '/profile/changePassword'] },
    { type: 'Address', URL: '/address', subURL: ['/additional'] }
  ]
